import { AppLogin } from "../Login";

const app = process.env.REACT_APP_APP;

export default function HomePage() {
  switch (app) {
    default:
      return <AppLogin />;
  }
}
